let loadPromise: Promise<typeof google> | undefined;

export function loadGoogleMaps(): Promise<typeof google> {
  if (window.google?.maps) return Promise.resolve(window.google);
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    const key = window.GR8CTZ_CONFIG?.mapsKey;
    if (!key) return reject(new Error("Google Maps configuration is missing."));
    const callback = `__gr8ctzMapsReady${Date.now()}`;
    (window as unknown as Record<string, unknown>)[callback] = () => {
      delete (window as unknown as Record<string, unknown>)[callback];
      resolve(window.google);
    };
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&loading=async&v=weekly&libraries=geometry,marker&callback=${callback}`;
    script.async = true;
    script.onerror = () => reject(new Error("Google Maps failed to load."));
    document.head.append(script);
  });
  return loadPromise;
}
